import * as React from 'react';
import { connect } from 'react-redux';

import { FormField } from 'components/form';
import MixedSelectDropdown from 'components/inputs/mixed-select-dropdown/MixedSelectDropdown';

import { __t } from 'utils/language';
import { isArrayRequired } from 'utils/validators';
import {
  mapCountriesToMixedSelectDropdownItem,
  mapMixedSelectDropdownItemsToCountries
} from '../../utils';

import type {
  MixedSelectDropdownItem
} from 'types';
import type {
  CcmCampaignFormCreatorlessThunkDispatch as Dispatch,
  StateAsPartOfGlobal
} from '../../types';

type OwnProps = {
  mgsKey: string,
  className: string
};

type StateProps = {
  countries: Array<MixedSelectDropdownItem>
};

type DispatchProps = {
  onChangeCountries: (countries: Array<MixedSelectDropdownItem>) => void
};

type Props = OwnProps & StateProps & DispatchProps;

const Countries = ({
  mgsKey,
  className,
  countries,
  onChangeCountries
}: Props): JSX.Element => (
  <FormField
    showRequiredMark
    showValidationIcon={false}
    fontSize="small"
    label={__t(`${mgsKey}.countries.label`)}
    sublabel={__t(`${mgsKey}.countries.sublabel`)}
    labelType="highlighted"
    direction="column"
    validators={[
      isArrayRequired(countries.filter(c => c.isSelected))
    ]}
  >
    <div className={className}>
      <MixedSelectDropdown
        name={className}
        items={countries}
        placeholder={__t(`${mgsKey}.countries.placeholder`)}
        withMulti
        withRemovable
        withSortable
        withCheckboxes
        withSelectAll
        onItemsToggle={onChangeCountries}
        onItemsRemove={onChangeCountries}
        onItemsRemoveAll={onChangeCountries}
        onItemsToggleAll={onChangeCountries}
      />
    </div>
  </FormField>
);

const mapStateToProps = ({ ccmCampaignFormCreatorless }: StateAsPartOfGlobal): StateProps => ({
  countries: mapCountriesToMixedSelectDropdownItem(
    ccmCampaignFormCreatorless.regions,
    ccmCampaignFormCreatorless.form.countries
  )
});

const mapDispatchToProps = (dispatch: Dispatch): DispatchProps => ({
  onChangeCountries: countries => dispatch({
    type: 'creatorless-campaign-countries-update',
    payload: {
      countries: mapMixedSelectDropdownItemsToCountries(countries)
    }
  })
});

export default connect(mapStateToProps, mapDispatchToProps)(Countries);
